import { useMutation, useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner, { InlineSpinner } from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { createContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BasicInfoView from "./BasicInfoView";
import CostView from "./CostView";
import { ARCHIVE_PRODUCT, FETCH_GEAR_DETAIL, SAVE_GEAR } from "./graphql";
import ImagesView from "./ImagesView";
import InventoryView from "./InventoryView";

export const GearContext = createContext({});

const defaultValues = {
  supplierName: "",
  supplierId: null,
  leadtime: null,
  currency: "CNY",
  moq: 1,
  prices: [{ qty: 1, price: 0 }],
};

const GearDetailPage = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(FETCH_GEAR_DETAIL, {
    variables: { id },
    fetchPolicy: "cache-and-network",
  });
  const [save, saveRes] = useMutation(SAVE_GEAR, {
    onCompleted() {
      Alert("success", "Item saved.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: [{ query: FETCH_GEAR_DETAIL, variables: { id } }],
    awaitRefetchQueries: true,
  });
  const navigate = useNavigate();
  const [archive, archiveRes] = useMutation(ARCHIVE_PRODUCT, {
    onCompleted() {
      Alert("success", "Item archived.");
      navigate("./..");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const gear = data.product;

  const gearData = { ...defaultValues, ...JSON.parse(gear.gearData) };

  console.log("gearData", gearData);

  function onChange(values) {
    save({ variables: { id, ...values } });
  }

  function archiveHandler() {
    if (window.confirm("Are you sure you want to archive this item?")) {
      archive({ variables: { id } });
    }
  }

  return (
    <GearContext.Provider value={{ id, gear, gearData, save, saveRes }}>
      <Page
        title={`Marketing Gear: ${gear.name}`}
        backTo="./.."
        rightButtons={
          <div className="flex items-center space-x-6">
            {saveRes.loading && (
              <div className="relative">
                <InlineSpinner size={18} />
              </div>
            )}
            <a
              href={`${process.env.REACT_APP_SERVER_ADMIN_URL}product/product/${id}`}
              target="_blank"
            >
              Admin
            </a>
          </div>
        }
      >
        <div className="p-6 grid grid-cols-12 gap-6">
          <div className=" col-span-8 space-y-6">
            <BasicInfoView />
            <CostView />
            <InventoryView productId={id} />
          </div>

          <div className=" col-span-4 space-y-6">
            <ImagesView
              name={gear.name}
              images={gear.imageUrls}
              onChange={onChange}
            />

            <div className="flex justify-end">
              <Button
                danger
                onClick={archiveHandler}
                loading={archiveRes.loading}
              >
                Archive Product
              </Button>
            </div>
          </div>
        </div>
      </Page>
    </GearContext.Provider>
  );
};

export default GearDetailPage;
